import { useConvexAuth } from "convex/react";
import { NoUser } from "./components/no-user";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "../../shared/models";

export const Landing = () => {
    const { isLoading, isAuthenticated } = useConvexAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (isAuthenticated) {
            navigate(MainRoutes.Progress);
        }
    }, [isAuthenticated]);
    return (
        <section className="min-h-screen bg-background flex">
            { !isAuthenticated ? <NoUser/> : '' }
        </section>
    );
}
